import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { Badge } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import siteLogo from "../assets/svg/revbox-logo.svg";
import {
    publisherDashboardMenu,
    publisherCustomerMenu,
    publisherInventoryMenu,
    publisherLeadsMenu,
    publisherFinanceMenu,
    publisherMenu,
    advertiserDashboardMenu,
    advertiserCampaignMenu,
    advertiserBillingMenu,
    adminMenu,
    dashboardMenu,
    applicationsMenu,
    pagesMenu,
    uiElementsMenu
} from "../data/Menu";

export default class Sidebar extends Component {
    toggleFooterMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-header">
                    <Link to="/" className="sidebar-logo">
                        <object type="image/svg+xml" data={siteLogo} className="w-100" aria-label="svg image"></object>
                    </Link>
                </div>
                <PerfectScrollbar className="sidebar-body" ref={ref => this._scrollBarRef = ref}>
                    <SidebarMenu onUpdateSize={() => this._scrollBarRef.updateScroll()} />
                </PerfectScrollbar>
                <div className="sidebar-footer">
                    <div className="sidebar-footer-top">
                        <div className="sidebar-footer-thumb">
                            <img src={userAvatar} alt="" />
                        </div>
                        <div className="sidebar-footer-body">
                            <h6><Link to="../pages/profile.html">Nick Hopper</Link></h6>
                            <p>Admin Account</p>
                        </div>
                        <Link onClick={this.toggleFooterMenu} to="" className="dropdown-link"><i className="ri-arrow-down-s-line"></i></Link>
                    </div>
                    <div className="sidebar-footer-menu">
                        <nav className="nav">
                            <Link to=""><i className="ri-question-line"></i> Documentation</Link>
                        </nav>
                        <hr />
                        <nav className="nav">
                            <Link to=""><i className="ri-refund-line"></i> Revbox Billing</Link>
                            <Link to="/advertiser/settings"><i className="ri-user-settings-line"></i> Account Settings</Link>
                            <Link to="/advertiser/campaign/new"><i className="ri-add-line"></i> New Campaign</Link>
                        </nav>
                        <hr />
                        <nav className="nav">
                            <Link to="/pages/signin"><i className="ri-logout-box-r-line"></i> Log Out</Link>
                        </nav>
                    </div>
                </div>
            </div>
        )
    }
}

class SidebarMenu extends Component {
    populateMenu = (m) => {
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink to={sm.link} className="nav-sub-link" key={key}>{sm.label}</NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink to={m.link} className="nav-link"><i className={m.icon}></i> <span>{m.label}</span></NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub"><i className={m.icon}></i> <span>{m.label}</span></div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    // Toggle menu group
    toggleMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    // Toggle submenu while closing siblings' submenu
    toggleSubMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');

        this.props.onUpdateSize();
    }

    render() {
        return (
            <React.Fragment>
                <div className="nav-group show nav-publisher">
                    <div className="nav-label" onClick={this.toggleMenu}>Dashboards</div>
                    {this.populateMenu(publisherDashboardMenu)}
                </div>
                <div className="nav-group show nav-publisher">
                    <div className="nav-label" onClick={this.toggleMenu}>Inventory</div>
                    {this.populateMenu(publisherInventoryMenu)}
                </div>
                <div className="nav-group show nav-publisher">
                    <div className="nav-label" onClick={this.toggleMenu}>Leads</div>
                    {this.populateMenu(publisherLeadsMenu)}
                </div>
                <div className="nav-group show nav-publisher">
                    <div className="nav-label" onClick={this.toggleMenu}>Customers</div>
                    {this.populateMenu(publisherCustomerMenu)}
                </div>
                <div className="nav-group show nav-publisher">
                    <div className="nav-label" onClick={this.toggleMenu}>Finance</div>
                    {this.populateMenu(publisherFinanceMenu)}
                </div>
                <div className="nav-group show nav-advertiser account">
                    <div className="nav-label" onClick={this.toggleMenu}>Account</div>
                    {this.populateMenu(advertiserDashboardMenu)}
                </div>
                <div className="nav-group show nav-advertiser">
                    <div className="nav-label" onClick={this.toggleMenu}><Badge bg="primary" className="me-1">ABC Bank</Badge> Campaigns</div>
                    {this.populateMenu(advertiserCampaignMenu)}
                </div>
                <div className="nav-group show nav-advertiser">
                    <div className="nav-label" onClick={this.toggleMenu}>Billing</div>
                    {this.populateMenu(advertiserBillingMenu)}
                </div>
                <div className="nav-group show nav-admin">
                    <div className="nav-label" onClick={this.toggleMenu}>Admin</div>
                    {this.populateMenu(adminMenu)}
                </div>
                <div className="nav-group show nav-other">
                    <div className="nav-label" onClick={this.toggleMenu}>Inventory</div>
                    {this.populateMenu(applicationsMenu)}
                </div>
                <div className="nav-group show nav-other">
                    <div className="nav-label" onClick={this.toggleMenu}>Customers</div>
                    {this.populateMenu(pagesMenu)}
                </div>
                <div className="nav-group show nav-other">
                    <div className="nav-label" onClick={this.toggleMenu}>Dashboard</div>
                    {this.populateMenu(dashboardMenu)}
                </div>
                <div className="nav-group show nav-other">
                    <div className="nav-label" onClick={this.toggleMenu}>Billing</div>
                    {this.populateMenu(uiElementsMenu)}
                </div>
            </React.Fragment>
        )
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body").classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});